/*
 * Validator Class 
 * @DESC  simplae validation class
*/
class Validator {
	simpleValidation(o) {
	    if (o.val === '') {
	        this.show_popup(o.err_1);
	        return false;
	    } else {
	        return true;
	    }
	}
	// email validation 
	email_validation(o) {
	  if (o.val === "") {
	        this.show_popup(o.err_1);
	        return false;
	  } else {
        if (o.expression.test(o.val) === false) {
            this.show_popup(o.err_2);
            return false;
        } else {
            return true;
        }

	  }

	}
	// regx validation 
	regx_validation( obj ) {
	    if ( obj.val === '' ) {
	        this.show_popup(obj.err_1);
	        return false;
	    } else {
	        if (obj.expression.test(obj.val)) {
	            return true;
	        } else {
	            this.show_popup(obj.err_2);
	            return false;
	        }
	    }
	}
	// alert 
	show_popup(msg) {
	    alert(msg);
	    
	};
}

export default Validator ;


// WEBPACK FOOTER //
// ./src/Utility/Validator/Validator.js